(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["t-collection-nav"] && !Shopify.designMode) return;
  try {
    
  for (const bar of document.querySelectorAll('[data-collection-nav]')) {
    if (bar.dataset.collectionNavReady) continue;
    bar.dataset.collectionNavReady = 'true';

    const list = bar.querySelector('.collection-nav__list');
    if (!list) continue;

    // Re-queried on every call rather than captured: the theme editor re-renders
    // the section, which replaces these nodes and would leave a stale reference
    // pointing at a detached element.
    //
    // Bound to `resize` only. It used to also listen for the list's `scroll`,
    // which fought the visitor: scrolling the row away from the active tab
    // immediately yanked it back, so browsing the categories by scrolling was
    // impossible. That was survivable when only phones scrolled and the active
    // tab was near the start; once the row scrolls on desktop too -- long list,
    // active tab often mid-way -- it made the feature unusable. The reveal is
    // still wanted when the viewport changes under a fixed scroll position
    // (rotating a phone, resizing a desktop window), which resize covers.
    const revealOnResize = () => {
      const active = bar.querySelector('.collection-nav__link--active');
      if (!active) return;

      const max = list.scrollWidth - list.clientWidth;
      const visibleEnd = list.scrollLeft + list.clientWidth;
      if (active.offsetLeft < list.scrollLeft || active.offsetLeft + active.clientWidth > visibleEnd) {
        // Bias towards the leading edge rather than the exact centre: a jump to
        // the middle on load reads as the page scrolling on its own.
        list.scrollTo({ left: Math.min(Math.max(0, active.offsetLeft - 16), max), behavior: 'smooth' });
      }
    };

    // Centre the active tab on load, before any listener can fire.
    const activeOnLoad = bar.querySelector('.collection-nav__link--active');
    if (activeOnLoad) {
      list.scrollLeft = Math.max(0, activeOnLoad.offsetLeft - (list.clientWidth - activeOnLoad.clientWidth) / 2);
    }

    /* ---------------------------------------------------------------------
       Scroll arrows.

       The row's scrollbar is hidden, so without these a mouse-only visitor
       has nothing to click, drag or focus: trackpad swipe and shift+wheel are
       invisible affordances. The buttons are the visible control. They are
       rendered `hidden` and stay that way unless the row actually overflows,
       so a category list that fits shows no arrows.

       Below 600px the CSS keeps them at `display: none` regardless of what this
       script sets -- on a phone the row is dragged with a finger and the two
       buttons would only take width away from the tabs. This script therefore
       does not watch for the breakpoint: it manages `hidden` from the overflow
       alone and leaves the responsive half to CSS.
    --------------------------------------------------------------------- */
    const prev = bar.querySelector('[data-nav-arrow="prev"]');
    const next = bar.querySelector('[data-nav-arrow="next"]');
    if (!prev || !next) continue;

    // Sub-pixel scroll offsets make a naive `scrollLeft === 0` test flap near
    // the ends, which flickers the disabled state. One pixel of slack settles it.
    const EDGE = 1;

    const syncArrows = () => {
      const max = list.scrollWidth - list.clientWidth;

      // Overflow is measured against a pixel rather than `> 0`: on a fractional
      // device-pixel ratio a row a third of a pixel too wide reports as
      // overflowing and would show a pair of arrows that barely do anything.
      const overflowing = max > 1;

      prev.hidden = !overflowing;
      next.hidden = !overflowing;
      if (!overflowing) return;

      const atStart = list.scrollLeft <= EDGE;
      const atEnd = list.scrollLeft >= max - EDGE;

      // `disabled`, not merely dimmed: a screen reader then reports the control
      // as unavailable instead of leaving a focusable button that does nothing.
      prev.disabled = atStart;
      next.disabled = atEnd;
    };

    // A step of ~70% of the visible width: far enough that two clicks cover a
    // long list, close enough that the visitor does not overshoot the tab they
    // were reading. Stepping by a whole tab is too slow with a dozen of them.
    const step = () => Math.max(120, Math.round(list.clientWidth * 0.7));

    const nudge = (direction) => {
      const max = list.scrollWidth - list.clientWidth;
      const target = Math.min(Math.max(0, list.scrollLeft + direction * step()), max);
      list.scrollTo({
        left: target,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth',
      });
    };

    prev.addEventListener('click', () => nudge(-1));
    next.addEventListener('click', () => nudge(1));

    // Re-synced on scroll because the visitor can also move the row with a
    // trackpad or shift+wheel, and the disabled state has to follow. This
    // listener only updates two attributes; unlike the reveal listener that
    // used to live here, it never moves the row, so it cannot fight the visitor.
    list.addEventListener('scroll', syncArrows, { passive: true });

    const onViewportChange = () => {
      revealOnResize();
      syncArrows();
    };
    window.addEventListener('resize', onViewportChange, { passive: true });

    syncArrows();

    // The theme editor re-renders the section, which can change how many tabs
    // there are without the window ever resizing.
    if (window.Shopify && window.Shopify.designMode === true) {
      bar.addEventListener('shopify:section:load', syncArrows);
    }
  }

  } catch(e) { console.error(e); }
})();
})();
